import './services-style.css';
import { useState } from 'react';

function Services() {
    const [activeTab, setActiveTab] = useState('embroidery');

    const serviceCards = [
        // Uniforms
        {
            id: 1,
            type: 'uniforms',
            category: 'Institucional & Empresarial',
            title: 'Uniformes institucionales',
            description: 'Confeccionamos uniformes para colegios, empresas, instituciones médicas y más. Bordamos el logo o nombre directamente sobre la prenda con durabilidad.',
            image: '/images/product-uniform-10.jpeg',
            cta: 'Imagen profesional garantizada',
            bgColor: '#d4c5a0'
        },
        {
            id: 2,
            type: 'uniforms',
            category: 'Institucional & Empresarial',
            title: 'Uniformes empresariales',
            description: 'Diseñamos y confeccionamos uniformes empresariales que reflejan la identidad de tu marca con calidad y profesionalismo.',
            image: '/images/product-uniform-5.jpeg',
            cta: 'Uniformidad con estilo',
            bgColor: '#c9d4c0'
        },
        {
            id: 3,
            type: 'uniforms',
            category: 'Institucional & Empresarial',
            title: 'Uniformes deportivos',
            description: 'Confeccionamos uniformes deportivos con bordados duraderos y diseños personalizados para equipos y organizaciones.',
            image: '/images/product-uniform-4.jpeg',
            cta: 'Jugá con estilo',
            bgColor: '#d4c5a0'
        },
        // Embroidery
        {
            id: 4,
            type: 'embroidery',
            category: 'Arte & Personalización',
            title: 'Diseño y confección de bordados',
            description: 'Ofrecemos servicios de diseño y confección de bordados personalizados en prendas de vestir, accesorios y artículos promocionales, según sea lo encargado.',
            image: '/images/product-embroidery-7.jpeg',
            cta: 'Tu diseño, nuestra pasión',
            bgColor: '#c9d4c0'
        },
        {
            id: 5,
            type: 'embroidery',
            category: 'Hogar & Decoración',
            title: 'Artículos personalizados del hogar',
            description: 'Creamos artículos bordados para el hogar como almohadas, edredones, juegos de cama, manteles y toallas personalizadas con nombres, frases o diseños a elección.',
            image: '/images/product-embroidery-8.jpeg',
            cta: 'El lujo en tu vida',
            bgColor: '#d4c5a0'
        },
        {
            id: 6,
            type: 'embroidery',
            category: 'Costura & Moda',
            title: 'Confección de prendas de vestir',
            description: 'Proporcionamos la confección de cualquier tipo de prendas de vestir: camisas, pantalones, vestidos y más. Nos adaptamos a las necesidades y requerimientos de cada cliente.',
            image: '/images/product-embroidery-9.jpeg',
            cta: 'Confía en tu estilo',
            bgColor: '#c9d4c0'
        },
        {
            id: 7,
            type: 'embroidery',
            category: 'Arte & Personalización',
            title: 'Bordados personalizados',
            description: 'Diseños únicos y personalizados con la más alta calidad en bordado para todo tipo de prendas y accesorios.',
            image: '/images/product-embroidery-2.jpeg',
            cta: 'Creatividad sin límites',
            bgColor: '#d4c5a0'
        },
        {
            id: 8,
            type: 'embroidery',
            category: 'Arte & Personalización',
            title: 'Bordados personalizados',
            description: 'Bordados especializados para todo tipo de ocasión',
            image: '/images/product-embroidery-11.jpeg',
            cta: 'Diseños personalizables',
            bgColor: '#c9d4c0'
        },
        {
            id: 9,
            type: 'embroidery',
            category: 'Arte & Personalización',
            title: 'Bordados especiales',
            description: 'Trabajos especiales de bordado con diseños complejos y detallados para proyectos únicos.',
            image: '/images/product-embroidery-13.jpeg',
            cta: 'Detalles que importan',
            bgColor: '#d4c5a0'
        },
        // Liturgical
        {
            id: 10,
            type: 'liturgical',
            category: 'Fe & Tradición',
            title: 'Prendas litúrgicas',
            description: 'Elaboramos casullas, estolas, albas, roquetas y demás vestimentas religiosas adaptadas con diseños bordados de alta calidad, usando telas nobles y duraderas.',
            image: '/images/product-liturgical-6.jpeg',
            cta: 'Devoción hecha tela',
            bgColor: '#c9d4c0'
        },
        {
            id: 11,
            type: 'liturgical',
            category: 'Fe & Tradición',
            title: 'Ornamentos litúrgicos',
            description: 'Creamos ornamentos litúrgicos con bordados detallados que honran la tradición y la solemnidad de las ceremonias religiosas.',
            image: '/images/product-liturgical-3.jpeg',
            cta: 'Tradición y elegancia',
            bgColor: '#d4c5a0'
        },
        {
            id: 12,
            type: 'liturgical',
            category: 'Fe & Tradición',
            title: 'Vestimentas ceremoniales',
            description: 'Confeccionamos vestimentas ceremoniales para la iglesia con bordados artesanales y acabados de la más alta calidad.',
            image: '/images/product-liturgical-12.jpeg',
            cta: 'Solemnidad en cada puntada',
            bgColor: '#c9d4c0'
        }
    ];

    // Filter cards based on active tab
    const filteredCards = serviceCards.filter(card => {
        if (activeTab === 'uniforms') return card.type === 'uniforms';
        if (activeTab === 'embroidery') return card.type === 'embroidery';
        if (activeTab === 'liturgical') return card.type === 'liturgical';
        return true;
    });

    return (
        <section className="services">
            {/* Hero Section */}
            <div className="services__hero">
                <div className="services__hero-content">
                    <div className="services__hero-text">
                        <h1 className="services__hero-title">
                            <span className="services__hero-title--teal">Confeccionamos tus ideas.</span><br />
                            <span className="services__hero-title--dark">Bordamos calidad.</span>
                        </h1>
                        <p className="services__hero-description">
                            Más de 18 años creando prendas y artículos personalizados con bordados de alta calidad para empresas, instituciones y familias en Costa Rica.
                        </p>
                    </div>
                    <div className="services__hero-image">
                        <img 
                            src="/images/page-services-short-image.png" 
                            alt="Tu logo aquí - Bordado personalizado"
                        />
                    </div>
                </div>
            </div>

            {/* Featured Products Section */}
            <div className="services__featured">
                <h2 className="services__featured-title">Productos destacados</h2>
                <p className="services__featured-subtitle">
                    Confeccionamos y bordamos con amor por los detalles, para ofrecerte productos que combinan calidad, profesionalismo y confianza.
                </p>

                <div className="services__tabs">
                    <button 
                        className={`services__tab ${activeTab === 'uniforms' ? 'active' : ''}`}
                        onClick={() => setActiveTab('uniforms')}
                    >
                        Uniformes
                    </button>
                    <button 
                        className={`services__tab ${activeTab === 'embroidery' ? 'active' : ''}`}
                        onClick={() => setActiveTab('embroidery')}
                    >
                        Bordados
                    </button>
                    <button 
                        className={`services__tab ${activeTab === 'liturgical' ? 'active' : ''}`}
                        onClick={() => setActiveTab('liturgical')}
                    >
                        Ornamentos litúrgicos
                    </button>
                </div>

                <div className="services__cards-grid">
                    {filteredCards.map((card) => (
                        <div key={card.id} className="services__card" style={{ backgroundColor: card.bgColor }}>
                            <div className="services__card-image">
                                <img src={card.image} alt={card.title} />
                            </div>
                            <div className="services__card-content">
                                <span className="services__card-category">{card.category}</span>
                                <h3 className="services__card-title">{card.title}</h3>
                                <p className="services__card-description">{card.description}</p>
                                <p className="services__card-cta">{card.cta}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* work process */}
            <div className="services__process">
                <h2 className="services__process-title">Nuestro Proceso de Trabajo</h2>
                <p className="services__process-subtitle">Así damos vida a tus ideas</p>

                <div className="services__process-steps">
                    <div className="services__process-step">
                        <div className="services__process-number">01</div>
                        <div className="services__process-icon">
                            <img src="/images/pen-about-proyect.png" alt="Consulta" />
                        </div>
                        <h3>Consulta</h3>
                        <p>Analizamos tu logro o idea y te informamos sobre las mejores opciones para tu proyecto.</p>
                    </div>
                    <div className="services__process-step">
                        <div className="services__process-number">02</div>
                        <div className="services__process-icon">
                            <img src="/images/details-about-proyect.png" alt="Detalles" />
                        </div>
                        <h3>Detalles</h3>
                        <p>Definimos las necesidades de tu proyecto, desde color al mejor diseño acorde a tus necesidades.</p>
                    </div>
                    <div className="services__process-step">
                        <div className="services__process-number">03</div>
                        <div className="services__process-icon">
                            <img src="/images/product-about-proyect.png" alt="Producción" />
                        </div>
                        <h3>Producción</h3>
                        <p>Bordamos a mano todos los diseños creados con calidad, con todo los detalles.</p>
                    </div>
                    <div className="services__process-step">
                        <div className="services__process-number">04</div>
                        <div className="services__process-icon">
                            <img src="/images/delivery-about-proyect.png" alt="Entrega" />
                        </div>
                        <h3>Entrega</h3>
                        <p>Realizamos paso a paso revisiones, acordamos hora y día, dejando listas tu solicitud.</p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Services;
